import React from 'react'
import ListSMS from './listSMS'
import StatisticalSMS from './statisticalSMS'
import { useTranslation } from 'react-i18next'
import BasicTabs from 'components/BasicTabs'
import { ALL_PERMISSION } from 'constants/permission'

const LIST_SMS_KEY = "#list"
const STATISTICAL = "#statistical"

const SMS = () => {
  const { t: translation } = useTranslation()

  const listTab = [{
    key: LIST_SMS_KEY,
    label :translation("sms.tab.list"),
    permission: undefined,
    component: <ListSMS />
  },
  {
    key: STATISTICAL,
    label :translation("listCustomers.statistical"),
    permission: undefined,
    component: <StatisticalSMS />
  }
]

  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_SMS.permissionTab}/>
  )
}

export default SMS
